export default {"src":"/_next/static/media/latitude.e5500525.svg","height":57,"width":142,"blurWidth":0,"blurHeight":0};